module.exports = __webpack_public_path__ + "img/cassaprevint-logo.9471e372.png";